import React from 'react';

function Process() {
  return (
    <section className="process section-padding" style={{marginBottom: '-150px'}}>
      <div className="container">
        <div className="sec-head mb-80">
          <h6 className="sub-title main-color mb-25">What Drives Us</h6>
          <div className="bord pt-25 bord-thin-top d-flex align-items-center">
            <h2 className="fw-600">
              Our Core <span className="fw-200">Values</span>
            </h2>
            <div className="ml-auto">
              <a href="/light/spob/about" className="go-more">
                <span className="text">Learn More</span>
                <span className="icon ti-arrow-top-right"></span>
              </a>
            </div>
          </div>
        </div>
        <div className="row md-marg">
          <div className="col-lg-3 col-md-6 item md-mb50">
            <div className="icon-img-60 mb-30">
              <img src="/light/assets/imgs/serv-icons/3.png" alt="" />
            </div>
            <h5 className="mb-15">Community Empowerment</h5>
            <p>
              We place communities at the centre of everything we do, working from the
              grassroots up to drive meaningful, lasting change.
            </p>
            <div className="o-hidden">
              <a href="/light/spob/about" className="rmore to-in mt-30">
                <span className="sub-title">Read More</span>
                <img src="/light/assets/imgs/arrow-right.png" alt="" className="icon-img-20 ml-5" />
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 item md-mb50">
            <div className="icon-img-60 mb-30">
              <img src="/light/assets/imgs/serv-icons/4.png" alt="" />
            </div>
            <h5 className="mb-15">Educational Equity</h5>
            <p>
              We believe every Nigerian child deserves equal access to quality education,
              regardless of background or economic circumstance.
            </p>
            <div className="o-hidden">
              <a href="/light/spob/about" className="rmore to-in mt-30">
                <span className="sub-title">Read More</span>
                <img src="/light/assets/imgs/arrow-right.png" alt="" className="icon-img-20 ml-5" />
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 item sm-mb50">
            <div className="icon-img-60 mb-30">
              <img src="/light/assets/imgs/serv-icons/5.png" alt="" />
            </div>
            <h5 className="mb-15">Cultural Heritage</h5>
            <p>
              We are committed to preserving Nigeria's rich languages and traditions,
              championing cultural literacy for present and future generations.
            </p>
            <div className="o-hidden">
              <a href="/light/spob/about" className="rmore to-in mt-30">
                <span className="sub-title">Read More</span>
                <img src="/light/assets/imgs/arrow-right.png" alt="" className="icon-img-20 ml-5" />
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 item">
            <div className="icon-img-60 mb-30">
              <img src="/light/assets/imgs/serv-icons/6.png" alt="" />
            </div>
            <h5 className="mb-15">Environmental Stewardship</h5>
            <p>
              We promote sustainable habits and eco-conscious living, building a healthier
              environment for communities across Nigeria.
            </p>
            <div className="o-hidden">
              <a href="/light/spob/about" className="rmore to-in mt-30">
                <span className="sub-title">Read More</span>
                <img src="/light/assets/imgs/arrow-right.png" alt="" className="icon-img-20 ml-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;
